import type { SaveResult } from '../../push/save';
import { mapPushSaveError } from '../errors';

export function allSetFromSave(
  save: SaveResult,
  hasConfig: boolean,
  hasAuth: boolean
): { allSet: boolean; reason?: string } {
  if (!hasConfig) {
    return { allSet: false, reason: mapPushSaveError() };
  }
  if (!hasAuth) {
    return { allSet: false, reason: mapPushSaveError() };
  }
  if (save.ok) return { allSet: true };
  return { allSet: false, reason: mapPushSaveError() };
}

